<template>
  <v-container>
    <div class="back-nav">
      <!--        Intentionally Empty-->
    </div>

    <div class="header">
      <h1 class="mb-4 page-title d-sm-inline-block">
        <v-icon>$employees</v-icon>
        My Employees
      </h1>
      <div v-if="hasEmSub" class="float-sm-right">
        <v-btn
          class="mb-4 primary--text add-btn"
          depressed
          color="#FCBE32"
          :to="{ name: 'addEmployees' }"
          :block="$vuetify.breakpoint.xsOnly"
        >
          Add Employees
        </v-btn>
      </div>
    </div>

    <v-tabs hide-slider v-model="activeTab" class="secondary-nav">
      <v-tab
        v-for="tab in tabs"
        :key="`${tab.name}-tab`"
        :to="`#${tab.route}`"
        >{{ tab.name }}</v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item
        v-for="tab in tabs"
        :key="`${tab.name}-tabitem`"
        :value="tab.route"
      >
        <component :is="tab.component" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import EmployeesList from "./EmployeesList";
import EmployeesUploadHistory from "./EmployeesUploadHistory";
import { getCurrentUser } from "@/services/shared";

const tabs = [
  {
    name: "Employees",
    route: "list",
    component: EmployeesList
  },
  {
    name: "Upload History",
    route: "history",
    component: EmployeesUploadHistory
  }
];
export default {
  name: "Employees",
  data: () => ({
    tabs,
    activeTab: null
  }),
  components: {
    EmployeesList,
    EmployeesUploadHistory
  },
  computed: {
    hasEmSub() {
      return getCurrentUser().hasEmployeeSubscription;
    }
  }
};
</script>

<style lang="sass" scoped>
.add-btn
  font-size: 1rem
</style>
